import { z } from "zod";
export const PrivacyLifecycleRecordV1Schema = z
    .object({
    schemaVersion: z.literal("privacy-lifecycle-record.v1.0"),
    controlId: z.enum([
        "privacy_notice",
        "consent_where_required",
        "access_export",
        "delete_request",
        "retention_policy",
        "subprocessor_register",
    ]),
    status: z.enum(["DOCUMENTED", "IMPLEMENTED", "DEFERRED"]),
    evidenceRef: z.string().min(1),
})
    .strict();
export const DEFAULT_PRIVACY_LIFECYCLE_REGISTRY = [
    { schemaVersion: "privacy-lifecycle-record.v1.0", controlId: "privacy_notice", status: "DOCUMENTED", evidenceRef: "docs/enrein-governance/locked-reference/Enrein_Product_Constitution_v1.1_LOCKED.md" },
    { schemaVersion: "privacy-lifecycle-record.v1.0", controlId: "consent_where_required", status: "IMPLEMENTED", evidenceRef: "apps/api/src/routes/client-intake.ts" },
    { schemaVersion: "privacy-lifecycle-record.v1.0", controlId: "access_export", status: "IMPLEMENTED", evidenceRef: "apps/api/src/routes/departure-kit.ts" },
    { schemaVersion: "privacy-lifecycle-record.v1.0", controlId: "delete_request", status: "DEFERRED", evidenceRef: "reports/active-plans/ENREIN_V1_OWNER_DECISIONS_P2.0.2.json" },
    { schemaVersion: "privacy-lifecycle-record.v1.0", controlId: "retention_policy", status: "IMPLEMENTED", evidenceRef: "packages/shared-contracts/src/departure/post-departure-retention-policy.ts" },
    { schemaVersion: "privacy-lifecycle-record.v1.0", controlId: "subprocessor_register", status: "DOCUMENTED", evidenceRef: "docs/enrein-governance/locked-reference/ENREIN_FULL_BLUEPRINT_v1.1_LOCKED.md" },
];
export function privacyLifecycleRegistryComplete() {
    return DEFAULT_PRIVACY_LIFECYCLE_REGISTRY.every((row) => row.status !== "DEFERRED" || row.controlId === "delete_request");
}
//# sourceMappingURL=privacy-lifecycle-registry.js.map